import { formatCurrency } from "@/utils/formatCurrency";
import type { TopupHistoryDetailData } from "@/types/topup/historydetail";
import { safeFormatDateTime } from "@/utils/formatDate";
import { ArrowRight } from "lucide-react";

type TopupDetailCardProps = {
  topup?: TopupHistoryDetailData | null;
};

export default function TopupDetailCard({ topup }: TopupDetailCardProps) {
  return (
    <div className="mt-4 flex flex-col gap-4">
      <div className="flex items-center gap-2 text-lg font-semibold text-secondary-foreground md:text-xl">
        Top-up Details
      </div>

      <div className="group rounded-2xl bg-card p-4 shadow-xl transition-shadow hover:shadow-2xl">
        <div className="flex flex-col gap-4">
          <div className="grid grid-cols-1 items-center gap-4 md:grid-cols-[1.7fr_1.2fr_1.1fr_1.1fr_auto]">
            <div className="flex flex-col gap-1 text-xs font-medium text-field">
              <p className="text-xs font-medium text-muted md:text-sm">
                E-Invoice No
              </p>
              <p className="text-sm font-medium text-muted-foreground md:text-base">
                {topup?.eInvoiceNo ?? "-"}
              </p>
            </div>
            <div className="flex flex-col gap-1 text-xs font-medium text-field">
              <p className="text-xs font-medium text-muted md:text-sm">
                Purchase Date/Time
              </p>
              <p className="text-sm font-medium text-muted-foreground md:text-base">
                {safeFormatDateTime(topup?.purchasedDateTime)}
              </p>
            </div>
            <div className="flex flex-col gap-1 text-xs font-medium text-field">
              <p className="text-xs font-medium text-muted md:text-sm">
                Payment Method
              </p>
              <p className="text-sm font-medium text-muted-foreground md:text-base">
                {topup?.paymentMethod}
              </p>
            </div>
            <div className="flex flex-col gap-1 text-xs font-medium text-field">
              <p className="text-xs font-medium text-muted md:text-sm">
                Total Amount
              </p>
              <p className="text-sm font-medium text-muted-foreground md:text-base">
                {topup?.totalAmount != null
                  ? formatCurrency(topup.totalAmount)
                  : "-"}
              </p>
            </div>
               <div className="flex flex-col gap-1 text-xs font-medium text-field md:items-center">
              <p className="text-xs font-medium text-muted md:text-sm">
                E-Invoice Status
              </p>
              <div className="rounded-lg bg-background text-center capitalize px-2 py-1 text-xs font-medium text-primary w-fit">
                {topup?.eInvoiceStatus ?? "-"}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-lg font-semibold text-secondary-foreground md:text-xl md:mt-3">
        Top-up Tickets
      </div>
      {topup?.topUpHistoryDetail.map((item, index) => (
        <div className="group rounded-2xl bg-card p-4 shadow-xl transition-shadow hover:shadow-2xl">
          <div
            key={`${item.routeGroupName}-${index}`}
            className="flex flex-col gap-4"
          >
            <div className="flex flex-col gap-1">
              <p className="text-xs font-medium text-muted md:text-sm">
                Destination
              </p>
              <p className="text-sm font-semibold flex items-center gap-1 text-muted-foreground md:text-base">
                <span>{item.routeGroupName.split(" - ")[0]}</span>
                <ArrowRight
                  size={14}
                  className="shrink-0 text-muted-foreground"
                  aria-hidden="true"
                />
                <span>{item.routeGroupName.split(" - ")[1]}</span>
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
              <div className="flex flex-col gap-1">
                <p className="text-xs font-medium text-muted md:text-sm">
                  Adult (Malaysia)
                </p>
                <p className="text-2xl font-semibold text-heading md:text-[32px]">
                  {item.adult}
                </p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-xs font-medium text-muted md:text-sm">
                  Child (Malaysia)
                </p>
                <p className="text-2xl font-semibold text-heading md:text-[32px]">
                  {item.child}
                </p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-xs font-medium text-muted md:text-sm">
                  Adult (Foreigner)
                </p>
                <p className="text-2xl font-semibold text-heading md:text-[32px]">
                  {item.adultForeigner}
                </p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-xs font-medium text-muted md:text-sm">
                  Child (Foreigner)
                </p>
                <p className="text-2xl font-semibold text-heading md:text-[32px]">
                  {item.childForeigner}
                </p>
              </div>
              <div className="flex flex-col gap-1">
                <p className="text-xs font-medium text-muted md:text-sm">
                  Local
                </p>
                <p className="text-2xl font-semibold text-heading md:text-[32px]">
                  {item.local}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
